import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock, Users, CheckCircle, AlertCircle } from 'lucide-react';
import { Button } from './ui/Button';
import { submitForm } from '../utils/googleSheets';
const teamMembers = [{
  name: 'חיליק בן ארי',
  role: 'בעלים ומנכ"ל',
  description: 'מה שצריך צריך',
  image: 'https://cdn.magicpatterns.com/uploads/cecfzHhRRwNr4mA7vfMWq9/IMG-20251210-WA0046.jpg'
}, {
  name: 'עמית גורפינקל',
  role: 'חותר אולימפי לשעבר',
  description: 'מדריך סרפסקי מוסמך ותותח',
  image: 'https://cdn.magicpatterns.com/uploads/pkzar27jAH2ucorPUZWRki/עמית.jpg'
}, {
  name: 'נחום שחר',
  role: 'מדריך וינג פויל וסאפ',
  description: 'ייקח אתכם לקצה ויעזור לך להבין שהכל אפשרי. מטפל ומלווה אנשים מעל 25 שנה',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iW5tDwJ2HUr46iGT1Z7jZf/20250720_151627~2.jpg'
}, {
  name: 'עדי שמעוני',
  role: 'מדריכת סאפ',
  description: 'מחברת בין ים, קצב ונשימה — תמיד עם אנרגיה גבוהה, דואגת שכל חתירה תהיה מסע מעצים לגוף ולנשמה',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/g3L2o1s7VgiojWaLHWmHmc/IMG-20251202-WA0026_%281%29.jpg'
}, {
  name: 'אושרת ישורון',
  role: 'הלב הפועם של המועדון',
  description: 'תמיד עם חיוך ומילה טובה תקבל את פניכם במשרד עם ים אהבה',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3ya3KhkEpguPp1yNngSd5U/IMG-20251202-WA0023_%281%29.jpg'
}];
interface ContactSectionProps {
  showTeam?: boolean;
}
export function ContactSection({
  showTeam = true
}: ContactSectionProps) {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<{
    type: 'success' | 'error' | null;
    message: string;
  }>({
    type: null,
    message: ''
  });
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({
      type: null,
      message: ''
    });
    try {
      const result = await submitForm({
        ...formData,
        type: 'צור קשר',
        source: 'דף הבית - צור קשר'
      });
      if (result.success) {
        setSubmitStatus({
          type: 'success',
          message: 'תודה! הפנייה שלך נשלחה בהצלחה. ניצור איתך קשר בקרוב.'
        });
        // ניקוי הטופס
        setFormData({
          name: '',
          phone: '',
          email: '',
          message: ''
        });
      } else {
        setSubmitStatus({
          type: 'error',
          message: result.message
        });
      }
    } catch (error) {
      setSubmitStatus({
        type: 'error',
        message: 'אירעה שגיאה בשליחת הפנייה. אנא נסה שוב.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };
  return <>
      {/* Team Section */}
      {showTeam && <section className="py-24 bg-gradient-to-b from-gray-50 to-white" data-id="element-65" data-mp="2o4ax6qdxaaen">
          <div className="container mx-auto px-4" data-id="element-66" data-mp="2j7u73qn5xlyx">
            <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-67" data-mp="2f5z9aw4fxqpw">
              <div className="flex items-center justify-center gap-3 mb-4" data-id="element-68" data-mp="32tqk1vac1vp2">
                <Users className="w-10 h-10 text-[#0A5F8F]" data-id="element-69" data-mp="2xx089k5k9m9g" />
                <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F]" data-id="element-70" data-mp="1rg4wgek4g25n">
                  הצוות שלנו
                </h2>
              </div>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-71" data-mp="1mg8s2e7ii8pk">
                הכירו את האנשים שעושים את הקסם
              </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-72" data-mp="3f46h8skgvpeu">
              {teamMembers.map((member, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100" data-id="element-73" data-mp="31emgttecz48p" data-mpi={index}>
                  <div className="text-center" data-id="element-74" data-mp="28mt5af98v6xu">
                    {member.image ? member.name === 'נחום שחר' ? <div className="w-32 h-32 mx-auto mb-4 rounded-full border-2 border-[#0A5F8F] overflow-hidden" data-id="element-75" data-mp="2566q2tkvt595">
                          <img src={member.image} alt={member.name} className="w-full h-full object-cover" style={{
                  objectPosition: 'center 20%'
                }} data-id="element-76" data-mp="215mtps84u5o2" />
                        </div> : member.name === 'עדי שמעוני' ? <div className="w-32 h-32 mx-auto mb-4 rounded-full border-2 border-[#0A5F8F] overflow-hidden" data-id="element-77" data-mp="1higpbh8m7m09">
                          <img src={member.image} alt={member.name} className="w-full h-full object-cover" style={{
                  objectPosition: 'center 3%'
                }} data-id="element-78" data-mp="1w7lbf9ij6adn" />
                        </div> : <div className="w-32 h-32 mx-auto mb-4 rounded-full border-2 border-[#0A5F8F] overflow-hidden" data-id="element-79" data-mp="2yqt5x2hsjmfy">
                          <img src={member.image} alt={member.name} className="w-full h-full object-cover" style={{
                  objectPosition: 'center 15%'
                }} data-id="element-80" data-mp="38ip8oquto0qi" />
                        </div> : <div className="bg-gradient-to-br from-[#0A5F8F] to-[#0D7AB8] w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4 text-white text-2xl font-bold" data-id="element-81" data-mp="2oteqn67lt3p8">
                        {member.name.charAt(0)}
                      </div>}
                    <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-82" data-mp="92siei2j3w6m">
                      {member.name}
                    </h3>
                    <p className="text-[#0A5F8F] font-semibold mb-4" data-id="element-83" data-mp="j6qultr0nwsh">
                      {member.role}
                    </p>
                    <p className="text-gray-600 leading-relaxed" data-id="element-84" data-mp="eai81vahp1ba">
                      {member.description}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </section>}

      {/* Contact Section */}
      <section id="contact" className="py-24 bg-[#0A5F8F] text-white relative overflow-hidden" data-id="element-85" data-mp="eo8i2vlvoau">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-86" data-mp="3mn7fayci0qut" />

        <div className="container mx-auto px-4 relative z-10" data-id="element-87" data-mp="1ku9rjgxkwogq">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-88" data-mp="1gwc007gc5qa6">
            {/* Contact Info */}
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-89" data-mp="204kajo9gp59j">
              <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-90" data-mp="1geqg12fd4c1m">
                בואו לבקר אותנו
              </h2>
              <p className="text-blue-100 text-lg mb-12 max-w-md" data-id="element-91" data-mp="1lgfp4cj0yfn2">
                אנחנו נמצאים בחוף מעגן, בפינה השקטה והיפה ביותר של הכנרת. הצוות
                שלנו מחכה לכם!
              </p>

              <div className="space-y-8" data-id="element-92" data-mp="1cepxp6p57gpa">
                <div className="flex items-start gap-4" data-id="element-93" data-mp="31t4hdclb0ddx">
                  <div className="bg-white/10 p-3 rounded-full shrink-0" data-id="element-94" data-mp="31tntuds6q9kk">
                    <MapPin className="w-6 h-6" data-id="element-95" data-mp="36r63y7hxuuu5" />
                  </div>
                  <div data-id="element-96" data-mp="3gvw5ic9fjwxu">
                    <h3 className="font-bold text-xl mb-1" data-id="element-97" data-mp="3gx7agfem3aqj">כתובת</h3>
                    <p className="text-blue-100" data-id="element-98" data-mp="3bxb8smtdzve5">חוף מעגן, קיבוץ מעגן</p>
                    <p className="text-blue-100" data-id="element-99" data-mp="3buyinmdh6eq0">עמק הירדן</p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-100" data-mp="3pqanwnp9bnl6">
                  <div className="bg-white/10 p-3 rounded-full shrink-0" data-id="element-101" data-mp="3kwxywcgo1erw">
                    <Phone className="w-6 h-6" data-id="element-102" data-mp="3ggevwukhlc7" />
                  </div>
                  <div data-id="element-103" data-mp="3unj44iquhhjs">
                    <h3 className="font-bold text-xl mb-1" data-id="element-104" data-mp="3uoc3uzrdz6sf">טלפון</h3>
                    <p className="text-blue-100" dir="ltr" data-id="element-105" data-mp="chxrh58rn4w5">
                      052-2632784
                    </p>
                    <p className="text-blue-100" dir="ltr" data-id="element-106" data-mp="8gm12xi2ifmw">
                      053-3343172
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-107" data-mp="2ebdiw4cogns6">
                  <div className="bg-white/10 p-3 rounded-full shrink-0" data-id="element-108" data-mp="2a8qz8qq5u962">
                    <Clock className="w-6 h-6" data-id="element-109" data-mp="yd2ue2fx21nk" />
                  </div>
                  <div data-id="element-110" data-mp="yazxqzk9da9v">
                    <h3 className="font-bold text-xl mb-1" data-id="element-111" data-mp="ubzgvmlcchpi">שעות פעילות</h3>
                    <p className="text-blue-100" data-id="element-112" data-mp="ue3wh1slr55m">
                      מדי יום מהשעה 6:00 ועד שעת החשיכה
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Contact Form */}
            <motion.div className="bg-white rounded-3xl p-8 md:p-10 shadow-2xl text-gray-900" initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} data-id="element-113" data-mp="1i0aduenx1x8i">
              <h3 className="text-2xl font-bold mb-6 text-[#0A5F8F]" data-id="element-114" data-mp="1w0th78hfsf4c">
                השאירו פרטים
              </h3>

              {/* Success/Error Message */}
              {submitStatus.type && <div className={`mb-6 p-4 rounded-xl flex items-start gap-3 ${submitStatus.type === 'success' ? 'bg-green-50 text-green-800 border border-green-200' : 'bg-red-50 text-red-800 border border-red-200'}`} data-id="element-115" data-mp="28aj7wwwvwjl1">
                  {submitStatus.type === 'success' ? <CheckCircle className="w-5 h-5 shrink-0 mt-0.5" data-id="element-116" data-mp="2ma2a7930l0pf" /> : <AlertCircle className="w-5 h-5 shrink-0 mt-0.5" data-id="element-117" data-mp="2r95889kku6nw" />}
                  <p className="text-sm" data-id="element-118" data-mp="2w0n96xmlo78v">{submitStatus.message}</p>
                </div>}

              <form className="space-y-6" onSubmit={handleSubmit} data-id="element-119" data-mp="30yyhv515sbpi">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-120" data-mp="35zcs8tq8fxqp">
                  <div className="space-y-2" data-id="element-121" data-mp="35x023tabmh2k">
                    <label htmlFor="name" className="text-sm font-medium text-gray-700" data-id="element-122" data-mp="39zwpdxat31cu">
                      שם מלא
                    </label>
                    <input type="text" id="name" required value={formData.name} onChange={handleChange} disabled={isSubmitting} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#0A5F8F] focus:ring-2 focus:ring-[#0A5F8F]/20 outline-none transition-all bg-gray-50 focus:bg-white disabled:opacity-50 disabled:cursor-not-allowed" placeholder="ישראל ישראלי" data-id="element-123" data-mp="15xwe3c0px0b4" />
                  </div>
                  <div className="space-y-2" data-id="element-124" data-mp="1ymk75trpktz8">
                    <label htmlFor="phone" className="text-sm font-medium text-gray-700" data-id="element-125" data-mp="1yjo9m6jrw7bb">
                      טלפון
                    </label>
                    <input type="tel" id="phone" required value={formData.phone} onChange={handleChange} disabled={isSubmitting} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#0A5F8F] focus:ring-2 focus:ring-[#0A5F8F]/20 outline-none transition-all bg-gray-50 focus:bg-white disabled:opacity-50 disabled:cursor-not-allowed" placeholder="050-0000000" data-id="element-126" data-mp="3q8x9lvflq874" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-127" data-mp="2xl1hz54w36h7">
                  <label htmlFor="email" className="text-sm font-medium text-gray-700" data-id="element-128" data-mp="2xm46x7iniyuh">
                    אימייל
                  </label>
                  <input type="email" id="email" required value={formData.email} onChange={handleChange} disabled={isSubmitting} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#0A5F8F] focus:ring-2 focus:ring-[#0A5F8F]/20 outline-none transition-all bg-gray-50 focus:bg-white disabled:opacity-50 disabled:cursor-not-allowed" placeholder="your@email.com" data-id="element-129" data-mp="vtobwcr6qsjk" />
                </div>

                <div className="space-y-2" data-id="element-130" data-mp="2dxuuio73a9vm">
                  <label htmlFor="message" className="text-sm font-medium text-gray-700" data-id="element-131" data-mp="295jrvdkys9zd">
                    הודעה
                  </label>
                  <textarea id="message" rows={4} required value={formData.message} onChange={handleChange} disabled={isSubmitting} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#0A5F8F] focus:ring-2 focus:ring-[#0A5F8F]/20 outline-none transition-all bg-gray-50 focus:bg-white resize-none disabled:opacity-50 disabled:cursor-not-allowed" placeholder="אני מעוניין לשמוע עוד על..." data-id="element-132" data-mp="1z7nl0xz28172" />
                </div>

                <Button type="submit" disabled={isSubmitting} className="w-full text-lg shadow-lg shadow-blue-500/30 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-133" data-mp="joy0feotohhk">
                  {isSubmitting ? 'שולח...' : 'שלח הודעה'}
                </Button>
              </form>
            </motion.div>
          </div>
        </div>
      </section>
    </>;
}